import React from 'react';
import cls from 'classnames';
import './From.scss';

/**
 * @param {object} props
 * @param {boolean} checked
 * @param {boolean} disabled
 */

function CusCheckbox({
  checked,
  title,
  disable,
  onChange = () => { },
  ...props
}) {
  return (
    <div className="d-inline-flex align-items-center w-auto">
      <label className={cls('CusCheckbox d-flex flex-shrink-0')}>
        <input
          type="checkbox"
          checked={checked}
          style={{ display: 'none' }}
          onChange={onChange}
        />
        {checked && (
          <svg viewBox="0 0 10 10">
            <path d="M2 5 L4 8 L8 2" />
          </svg>
        )}
      </label>
      <span className="ml-3 text-justify" onClick={onChange}>{title}</span>
    </div>
  );
}

export { CusCheckbox };
